var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNewPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00026 7.86663C7.20026 7.86663 6.5447 7.61108 6.03359 7.09997C5.52248 6.58886 5.26693 5.9333 5.26693 5.1333C5.26693 4.32219 5.52248 3.66108 6.03359 3.14997C6.5447 2.63886 7.20026 2.3833 8.00026 2.3833C8.80026 2.3833 9.45859 2.63886 9.97526 3.14997C10.4919 3.66108 10.7503 4.32219 10.7503 5.1333C10.7503 5.9333 10.4919 6.58886 9.97526 7.09997C9.45859 7.61108 8.80026 7.86663 8.00026 7.86663ZM3.75026 13.6833C3.38359 13.6833 3.07248 13.5555 2.81693 13.3C2.56137 13.0444 2.43359 12.7333 2.43359 12.3666V11.8666C2.43359 11.4111 2.55026 11.0139 2.78359 10.675C3.01693 10.3361 3.32248 10.0777 3.70026 9.89997C4.45582 9.55552 5.18359 9.29997 5.88359 9.1333C6.58359 8.96663 7.28915 8.8833 8.00026 8.8833C8.72248 8.8833 9.43082 8.96941 10.1253 9.14163C10.8197 9.31386 11.5391 9.56663 12.2836 9.89997C12.6725 10.0666 12.9864 10.3194 13.2253 10.6583C13.4641 10.9972 13.5836 11.4 13.5836 11.8666V12.3666C13.5836 12.7333 13.4558 13.0444 13.2003 13.3C12.9447 13.5555 12.628 13.6833 12.2503 13.6833H3.75026Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewPerson);
export default __webpack_public_path__ + "static/media/icon_new_person.c7e44f14f962a973a3896385ad59a0fd.svg";
export { ForwardRef as ReactComponent };